export const ALL_SUBORDERS_TYPES = [
  'handofforder_transferorder',
  'receiptorder_transferorder',
  'passorder_transferorder',
  'loadingorder_transferorder',
  'unloadingorder_transferorder',
  'classificationorder'
]

export const ACCEPTED_STATUS_CODE = ['3', '4', '5', '6', '7']
